// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__-x3lp","ant-page-header-heading-title":"styles_ant-page-header-heading-title__JBfjH","table":"styles_table__urwZZ"};